import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSplit, setSplit,setIsSplitted } from "store/checkout/cart/cartSlice";
import { UTILS } from "utils";
import { useUserWallet } from "hooks";
import SplitBill from "./SplitBill";

export const SplitBillTypeKeys = {
  CUSTOM_AMOUNT: "CUSTOM-AMOUNT",
  DIVIDE_EQUALLY: "DIVIDE-EQUALLY",
  SELECTED_ITEMS: "SELECTED-ITEMS",
};

const DineInSplitBill = ({ open = false, setOpen = () => {} }) => {
  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);
  // Selectors --------------------------------
  const {
    cart,
    orderGrossAmount,
    itemsGrossAmount,
    split,
    totalOrdersGrossAmount,
    tipAmount,
    // isSplitted,
  } = useSelector((state) => state?.cart);
  const { ordered, splitedItems } = useSelector((state) => state.order);
  const { selectedStore } = useSelector((state) => state.store);
  const { discountInfo } = useSelector((state) => state.Discounts);
  const { selectedTip } = useSelector((state) => state.TipMethodsReducer);
  // State --------------------------------
  const [completeOrder, setCompleteOrder] = useState({
    itemsGrossAmount: 0,
    orderGrossAmount: 0,
  });
  const [customSplitAmount, setCustomSplitAmount] = useState(0.0);
  const [divideEqually, setDivideEqually] = useState({
    peopleAtTable: 1,
    forPeople: 1,
  });
  const [initialState, setInitialState] = useState();
  const [tempSplit, setTempSplit] = useState();
  const [allItems, setAllItems] = useState([]);
  const [alreadyPaidItems, setAlreadyPaidItems] = useState([]);
  const [remainingItems, setRemainingItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState();

  const userWallet = useUserWallet()
  const amount = UTILS.roundToTwoDecimals((completeOrder.order / 1) * 1);
  const rate = selectedStore?.taxRate || 0;


  // Handler --------------------------------
  const generateUniqueId = (item, sourceKey, orderId = null) => {
    const optionIds = (item.sections ?? [])
      .flatMap(sec => sec.options ?? [])
      .map(opt => opt.optionId)
      .sort()
      .join("-");

    return `${sourceKey}-${item.itemId}-${optionIds || "noOptions"}${orderId ? `-${orderId}` : ""}`;
  };

  const isSplitted = splitedItems?.length > 0 || ordered?.splitBills?.length > 0

  const handleCustomSplit = () => {
    const val = customSplitAmount;
    if (val === "") {
      dispatch(
        setSplit({
          ...split,
          amount: 0,
          tax: 0,
          totalAmount: 0,
          remainingAmount: 0,
        })
      );
      return;
    }

    let parsedValue = parseFloat(val);
    if (
      isNaN(parsedValue) ||
      parsedValue < 0 ||
      parsedValue > completeOrder.orderGrossAmount
    ) {
      console.warn("Invalid amount entered:", val);
      dispatch(clearSplit());
      return;
    }

    parsedValue = parseFloat(parsedValue.toFixed(2));
    const paidAmount = ordered?.splitPayed ?? 0;
    const remainingAmount = UTILS.roundToTwoDecimals(
      completeOrder.orderGrossAmount - parsedValue - paidAmount
    );

    dispatch(
      setSplit({
        ...split,
        ...tempSplit,
        remainingAmount,
        amount: parsedValue.toString(),
        totalAmount: parsedValue.toString(),
      })
    );
  };

  const calculateDivideEquallyAmount = (divideEqually) => {
    const orderGrossAmount = completeOrder.orderGrossAmount  || (totalOrdersGrossAmount ?? 0);
    const paidAmount = ordered?.splitPayed ?? 0;
    const totalPersons = divideEqually?.peopleAtTable || 1;
    const perPersonAmount = orderGrossAmount / totalPersons;
    const selectedPersons = divideEqually?.forPeople || 1;
    const amount = (perPersonAmount * selectedPersons) || 0; 
    const remainingAmount = orderGrossAmount - paidAmount - amount;
    return {
      amount,
      remainingAmount,
      perPersonAmount,
    }
  }

  const handleDivideEqually = () => {
    if (divideEqually?.peopleAtTable > 0 && divideEqually?.forPeople > 0) {
      const { amount, remainingAmount } = calculateDivideEquallyAmount(divideEqually);
      dispatch(
        setSplit({
          ...split,
          ...tempSplit,
          ...divideEqually,
          type: SplitBillTypeKeys.DIVIDE_EQUALLY,
          remainingAmount: remainingAmount,
          amount: amount,
          totalAmount: amount,
        })
      );
    }
  };

  const handleSelectedItems = (item) => {
    const upadte = {
      ...tempSplit,
      selectedItems: selectedItems,
    };
    dispatch(setSplit(upadte));
  };

  const handleClearLocalState = () => {
    if(!isSplitted){
      setSelectedOption(null);
      setCustomSplitAmount(0);
      setDivideEqually({ peopleAtTable: 1, forPeople: 1 });
      setSelectedItems([]);
    }
    setInitialState(null);
    setTempSplit(null);
  };

  const handleClearSplitBill = () => {
    dispatch(clearSplit());
    handleClearLocalState();
  };

  const handleSelectOption = (option) => {
    if (isSplitted) return;
    setSelectedOption(option);
    dispatch(clearSplit());
    // dispatch(setSplit(split === option ? null : option));
    setTempSplit(split === option ? null : {...(split || {}),...option});
  };

  const selectedItemsAmountCalculation = (split) => {
    const { itemsGrossAmount, itemsNetPrice, orderGrossAmount } =
        UTILS.calculateCartGrossAmount(
          split?.selectedItems ?? [],
          discountInfo,
          userWallet,
          ordered
        );

      const tax = parseFloat(
        (parseFloat(itemsGrossAmount) * (rate / 100)).toFixed(2)
      );
      const paidAmount = ordered?.splitPayed ?? 0;

      let totalTipAmount = 
        (tipAmount ?? 0) + (ordered?.totalTipAmount ?? 0)
      

      totalTipAmount = (totalTipAmount / parseInt(allItems.length))

      totalTipAmount = totalTipAmount * parseInt(split.selectedItems.length)
      
      const totalAmount = (
        tax + itemsGrossAmount + totalTipAmount
      );
      
      const remainingAmount =  completeOrder.orderGrossAmount - totalAmount - paidAmount;

      return {
        totalAmount,
        remainingAmount,
        tax,
        tipAmount:totalTipAmount,
        amount: itemsGrossAmount ,
        tax
      }
  }

  // Constants --------------------------------
  const SplitBillOptions = [
    {
      title: "Custom Amount",
      type: SplitBillTypeKeys.CUSTOM_AMOUNT,
      amount: 0,
      tax: 0,
      totalAmount: 0,
      remainingAmount: 0,
    },
    {
      title: "Divide Equally",
      type: SplitBillTypeKeys.DIVIDE_EQUALLY,
      peopleAtTable: 1,
      forPeople: 1,
      amount,
      tax: 0,
      totalAmount: amount,
      remainingAmount: UTILS.roundToTwoDecimals(
        completeOrder.orderGrossAmount - amount
      ),
    },
    {
      title: "Pay for Specific Items",
      type: SplitBillTypeKeys.SELECTED_ITEMS,
      selectedItems: [],
      amount: 0,
      tax: 0,
      totalAmount: 0,
      remainingAmount: 0,
    },
  ];

  const callBackHasMap = {
    [SplitBillTypeKeys.CUSTOM_AMOUNT]: handleCustomSplit,
    [SplitBillTypeKeys.DIVIDE_EQUALLY]: handleDivideEqually,
    [SplitBillTypeKeys.SELECTED_ITEMS]: handleSelectedItems,
  };

  const propsHasMap = {
    [SplitBillTypeKeys.CUSTOM_AMOUNT]: {
      value: customSplitAmount,
      setValue: (value) => {
        setTempSplit({
          ...(split ?? {}),
          ...tempSplit,
          amount: value,
          totalAmount: value,
          remainingAmount: completeOrder.orderGrossAmount - (ordered?.splitPayed ?? 0) - value,
        });
        setCustomSplitAmount(+value);
      },
      minValue: 0,
      maxValue: completeOrder.orderGrossAmount - (ordered?.splitPayed ?? 0),
    },
    [SplitBillTypeKeys.DIVIDE_EQUALLY]: {
      value: divideEqually,
      setValue: (value) => {
        const { amount, remainingAmount, perPersonAmount } = calculateDivideEquallyAmount(value);
        setTempSplit({
          ...(split ?? {}),
          ...tempSplit,
          ...value,
          totalAmount: amount,
          remainingAmount,
          amount,
          perPersonAmount,
        });
        setDivideEqually(value);
      },
      completeOrder,
    },
    [SplitBillTypeKeys.SELECTED_ITEMS]: {
      value: selectedItems,
      setValue: (selectedItems) => {
        setSelectedItems(selectedItems);
        const { totalAmount, remainingAmount, tax, tipAmount, amount } =
          selectedItemsAmountCalculation({
            ...tempSplit,
            selectedItems: selectedItems,
          });
        setTempSplit({
          ...(split ?? {}),
          ...tempSplit,
          selectedItems,
          totalAmount,
          remainingAmount,
          amount,
          tax,
          tipAmount,
        });
      },
      allItems,
      completeOrder,
    },
  };

  // Handler --------------------------------

  const handleApplySplit =() => {
     callBackHasMap[selectedOption?.type]();
     // set split is automatically set isSplitted to true when split is applied, so we need to set it to false when split is applied in order to close the modal
    //  dispatch(setIsSplitted(false))
     setOpen(false);
    
  };

  const formatItem = (item, key, orderId = null, isInSplit=false) => {
    const quantity = item?.quantity || 0, paidFor = item?.selectedQunatity || 0;
    const selectedQunatity = item?.selectedQunatity != null
      ? quantity - item.selectedQunatity
      : quantity || 1;
    const remainingQunatity =  quantity - (item?.selectedQunatity || 0)


    let isSplitPending = false;
    if(item?.selectedQunatity && item?.selectedQunatity < quantity){
      isSplitPending = true;
    }
    return {
      ...item,
      key,
      orderId,
      uniqueId: generateUniqueId(item, key, orderId),
      selectedQunatity,
      paidFor,
      remainingQunatity,
      isSplitPending,
      already: isInSplit,
    };
  };

  const isItemInSplit = (itemId, orderId) =>
    splitedItems.find(
      (item) => item?.itemId === itemId && item?.orderId === orderId
    ) || false;
   
  useEffect(() => {
    const basketItems = cart?.map((item) => formatItem(item, "basket")) || [];
    const orderedItems = []
    const alreadyPaidItems = []
    const remainingItems = []
      ordered?.allOrders?.forEach((order) =>{
        order?.orderedMenu?.forEach((item) => {
          const splittedItem = isItemInSplit(item?.itemId, order._id);
          const isInSplit = splittedItem ? true : false;
          let obj = item;
          if (splittedItem) {
            obj = {
              ...item,
              ...splittedItem,
            };
          }
          const formattedItem = formatItem(obj, "old", order._id, isInSplit);
          if(formattedItem?.already && !formattedItem?.isSplitPending){
            alreadyPaidItems.push(formattedItem)
          }else{
            remainingItems.push(formattedItem)
          }
          orderedItems.push(formattedItem);
        })
      });

    setAllItems([...basketItems, ...remainingItems]);
    setAlreadyPaidItems(alreadyPaidItems)
    setRemainingItems(remainingItems)

  }, [cart, ordered?.allOrders]);

  // Update completeOrder amounts when itemsGrossAmount or ordered item prices or total order amount change
  useEffect(() => {
    if (itemsGrossAmount > 0 || ordered.orderesTotalItemsPrice > 0) {
      const totalItemsAmount = UTILS.roundToTwoDecimals(
        parseFloat(itemsGrossAmount ?? 0) +
          parseFloat(ordered?.orderesTotalItemsPrice ?? 0)
      );

      const orderGrossAmount = UTILS.roundToTwoDecimals(
        parseFloat(totalOrdersGrossAmount ?? 0)
      )

      setCompleteOrder({
        ...completeOrder,
        itemsGrossAmount: totalItemsAmount,
        orderGrossAmount: orderGrossAmount,
      });
    }
  }, [
    ordered.orderesTotalItemsPrice,
    itemsGrossAmount,
    totalOrdersGrossAmount,
  ]);

  useEffect(() => {
    if (split?.selectedItems) {
    const { totalAmount, remainingAmount, tax, tipAmount, amount } = selectedItemsAmountCalculation(split)
      dispatch(
        setSplit({
          ...split,
          tax,
          totalAmount,
          tipAmount:tipAmount,
          amount: itemsGrossAmount ,
          remainingAmount,
        })
      );
    }
  }, [split?.selectedItems]);

  // useEffect(() => {
  //   const totalPersons = split?.peopleAtTable;
  //   const selectedPersons = split?.forPeople;
  //   if (
  //     completeOrder.orderGrossAmount > 0 &&
  //     selectedPersons > 0 &&
  //     totalPersons >= selectedPersons
  //   ) {
  //     // Calculate per-person amount
  //     const perPersonAmount = completeOrder.orderGrossAmount / totalPersons;
  //     // Calculate total for selected number of persons
  //     const amount = UTILS.roundToTwoDecimals(
  //       perPersonAmount * selectedPersons
  //     );

  //     const paidAmount = ordered?.splitPayed ?? 0;
  //     const remainingAmount = UTILS.normalizeAmount(UTILS.roundToTwoDecimals(
  //       completeOrder.orderGrossAmount - parseFloat(amount) - parseFloat(paidAmount)
  //     ));

  //     // dispatch(
  //     //   setSplit({
  //     //     ...split,
  //     //     tax: 0,
  //     //     totalAmount: amount,
  //     //     amount,
  //     //     remainingAmount,
  //     //   })
  //     // );
  //   }
  // }, [split?.peopleAtTable, split?.forPeople]);

  // When split bills or order amount changes, update selected split option and split details in state/store
  useEffect(() => {
    if (ordered?.splitBills.length > 0) {
      const latestSplitBill = ordered.splitBills.reduce((mostPaid, current) =>
        current.remainingAmount < mostPaid.remainingAmount ? current : mostPaid
      );
      const { _id, ...rest } = latestSplitBill;
      const paidAmount = ordered?.splitPayed ?? 0;
      const orderGrossAmount = completeOrder.orderGrossAmount  || (totalOrdersGrossAmount ?? 0)
      
      let remainingAmount = 0;
      let updateObj = {};
      if (SplitBillTypeKeys.CUSTOM_AMOUNT === latestSplitBill?.type) {
        remainingAmount =
             orderGrossAmount -
              paidAmount -
              latestSplitBill?.remainingAmount
           
        const amount = latestSplitBill?.remainingAmount
          ? latestSplitBill?.remainingAmount
          : 0;
        updateObj = {
          remainingAmount,
          amount,
          totalAmount: amount,
          already: true,
        };
        setCustomSplitAmount(amount);
        setInitialState(amount);
      } else if (SplitBillTypeKeys.DIVIDE_EQUALLY === latestSplitBill?.type) {
        const splittedforPeople = ordered.splitBills.reduce(
          (total, bill) => total + (bill.forPeople || 0),
          0
        );
        const totalPersons = split?.peopleAtTable || 1;
        // const selectedPersons = (totalPersons || 0) - (splittedforPeople || 0) -1 || 1;
        const selectedPersons = 1;
        const perPersonAmount = orderGrossAmount / totalPersons;
        const amount = (perPersonAmount * selectedPersons) || 0;
        remainingAmount = orderGrossAmount - paidAmount - amount;
        setDivideEqually({
          peopleAtTable: totalPersons,
          forPeople: 1,
        });
        setInitialState({
          peopleAtTable: totalPersons,
          forPeople: 1,
        });
        updateObj = {
          remainingAmount,
          splittedforPeople,
          already: true,
          amount,
          totalAmount: amount,
        };
      }
      else if (SplitBillTypeKeys.SELECTED_ITEMS === latestSplitBill?.type && allItems.length > 0) {
        // Recalculate using your utility function
        const splitCalculation = selectedItemsAmountCalculation({
          selectedItems: remainingItems,
        });
      
        setSelectedItems(remainingItems);
        setInitialState(remainingItems);
      
        updateObj = {
          title: "Pay for Specific Items",
          type: SplitBillTypeKeys.SELECTED_ITEMS,
          selectedItems: remainingItems,
          tax: splitCalculation.tax,
          totalAmount: splitCalculation.totalAmount,
          tipAmount: splitCalculation.tipAmount,
          amount: splitCalculation.amount,
          remainingAmount: splitCalculation.remainingAmount,
          already: true,
        };
        setTempSplit({ ...rest, ...updateObj });
      }

      const selectedSplit = SplitBillOptions.find(
        (option) => option?.type === latestSplitBill?.type
      );
      if (selectedSplit) setSelectedOption(selectedSplit);
      dispatch(setSplit({ ...rest, ...updateObj }));
    } else {
      // Clear split bill data if no split bills exist
      handleClearSplitBill();
    }
  }, [completeOrder.orderGrossAmount, ordered?.splitBills]);

  useEffect(() => {
    // Cleanup: reset selected option when component unmounts
    return () => handleClearLocalState();
  }, []);

  return (
    <SplitBill
      {...{
        SplitBillOptions,
        selectedOption,
        cart,
        orderGrossAmount,
        itemsGrossAmount,
        split,
        totalOrdersGrossAmount,
        tipAmount,
        ordered,
        initialState,
        propsHasMap,
        open,
        tempSplit,
        selectedTip,
        rate,
        setTempSplit,
        callBackHasMap,
        handleApplySplit,
        handleSelectOption,
        handleCustomSplit,
        handleDivideEqually,
        handleClearLocalState,
        handleClearSplitBill,
        handleClose,
        setInitialState,
        isSplitted,
       
      }}
    />
  );
};

export default DineInSplitBill;
